<section class="section" style="padding-top: 10px !important">
  <div class="container container-xs">
    <div class="row">
      <div
        class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12 animated fadeIn"
      >
        <div class="row" *ngIf="loadingTemas || loadingBurbuja">
          <div class="col-12">
            <div class="alert alert-info text-center">
              <h4 class="alert-heading">Cargando</h4>
              <i class="fa fa-sync fa-spin fa-3x"></i>
              <p class="mb-0">Espera por favor...</p>
            </div>
          </div>
        </div>
        <div class="caminodemigas">
          <a href="#"
            ><i _ngcontent-hdm-c23="" class="fa fa-1x fa-home mr-1"></i> </a
          ><span
            ><a href="#"> {{ burbuja }}</a></span
          >
        </div>
        <h1 class="tema">
          <a type="button" class="btn btn-link" (click)="volver()"
            ><i class="fas fa-arrow-left"></i>
          </a>
          {{ burbuja }}
        </h1>
        <div *ngIf="loadingTemas == false && temas.length == 0">
          <h3>No encontramos temas.</h3>
        </div>
        <div class="row mt-3">
          <button
            type="button"
            (click)="habilitarOrdenar()"
            data-toggle="tooltip"
            title="Nuevo Tema"
            *ngIf="isAdmin && !ordenar && temas.length > 0"
            class="btn btn-outline-primary ordenar btn-sm"
          >
            <i class="fas fa-sort"></i> Ordenar
          </button>
          <button
            type="button"
            (click)="cancelarOrdenar()"
            *ngIf="isAdmin && ordenar"
            class="btn btn-outline-primary deshabilitar btn-sm"
          >
            <i class="fas fa-times"></i> Cancelar
          </button>
          <button
            type="button"
            (click)="guardarOrdenamiento()"
            *ngIf="isAdmin && ordenar"
            class="btn btn-outline-success guardar btn-sm"
          >
            <i class="far fa-save"></i> Guardar
          </button>
          <button
            type="button"
            (click)="nuevoTema()"
            data-toggle="tooltip"
            title="Habilitar Ordenamiento"
            *ngIf="(isAdmin || isContribuidor) && editar"
            class="btn btn-primary nuevaburbuja btn-sm"
          >
            <i class="fas fa-plus"></i> Nuevo Tema
          </button>
          <div class="col-12 pl-0 pr-0">
            <ul
              class="btn-toggle-nav list-unstyled fw-normal burbujalineal"
              cdkDropList
              (cdkDropListDropped)="drop($event)"
              [cdkDropListDisabled]="!ordenar"
              [cdkDropListData]="temas"
            >
              <li *ngFor="let tema of temas; let i = index" cdkDrag>
                <a>
                  <h3
                    class="h-100"
                    (mouseenter)="hoveredIndex = i"
                    (mouseleave)="hoveredIndex = null"
                  >
                    <a (click)="verPreguntas(tema.id)">
                      <i class="far fa-question-circle"></i>
                      {{ tema.descripcion }}
                    </a>
                    <a
                      (click)="editarTema(tema.id)"
                      *ngIf="(isAdmin || isContribuidor) && hoveredIndex == i"
                      class="btn_ico"
                    >
                      <i class="far fa-edit"></i>
                    </a>
                    <a
                      (click)="borrarTema(tema.id, tema.descripcion)"
                      *ngIf="isAdmin && hoveredIndex == i"
                      class="btn_ico"
                    >
                      <i class="far fa-trash-alt"></i>
                    </a>
                    <a (click)="verPreguntas(tema.id)">
                      <i class="fas fa-chevron-right mr-1 ml-1 letsgo"></i>
                    </a>
                  </h3>
                </a>
              </li>
            </ul>

            <div class="footer-notice">
              <p class="nososvos">
                ¿No encontraste lo que buscabas?
                <a
                  href="https://help.uade.edu.ar/help/preguntas/661"
                  class="btn btn-light"
                  ><i class="far fa-comments"></i> Contactános</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
  </div>
</section>
